import { render } from "./FormInputDropdown.vue?vue&type=template&id=51671d64"
import script from "./FormInputDropdown.vue?vue&type=script&lang=js"
export * from "./FormInputDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__